/**
 * Canonical hook for ceremony field completion mutation.
 * Replaces duplicate inline COMPLETE_CEREMONY_FIELD in PublicSigningPage + SigningCeremonyPage.
 */

import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

export const COMPLETE_CEREMONY_FIELD = gql`
  mutation CompleteCeremonyField($input: CompleteCeremonyFieldInput!) {
    completeCeremonyField(input: $input) {
      ceremonyId
      status
      fields {
        fieldIndex
        completed
      }
    }
  }
`;

export interface CeremonyFieldResult {
  ceremonyId: string;
  status: string;
  fields: Array<{
    fieldIndex: number;
    completed: boolean;
  }>;
}

interface CompleteCeremonyFieldData {
  completeCeremonyField: CeremonyFieldResult;
}

export function useCeremonyFieldCompletion() {
  const [completeField, { data, loading, error }] =
    useMutation<CompleteCeremonyFieldData>(COMPLETE_CEREMONY_FIELD);

  return {
    completeField: (ceremonyId: string, fieldIndex: number, value: string) =>
      completeField({
        variables: {
          input: { ceremonyId, fieldIndex, value },
        },
      }),
    result: data?.completeCeremonyField ?? null,
    loading,
    error,
  };
}
